/** Where a chart tooltip sits, in pixels inside the chart wrapper. */

export interface TipAnchor {
  x: number;
  y: number;
}

/** The anchor for an element, relative to a wrapper: top centre of the element. */
export function anchorWithin(wrapper: HTMLElement, element: Element): TipAnchor {
  const w = wrapper.getBoundingClientRect();
  const e = element.getBoundingClientRect();
  return { x: e.left - w.left + e.width / 2, y: e.top - w.top };
}
